<script type="text/ecmascript-6">
  const roomstartUrl = 'https://edu.9man.com/';
  const uploadUrl = 'https://edu.9man.com/';
//  const uploadUrl = 'https://www.9man.com/';
  const playUrl = 'https://edu.9man.com/';
  const editUrl = 'http://edu.9man.com/';
  const buyUrl = 'https://edu.9man.com/';
//  const buyUrl = 'http://192.168.1.126/';
  const liveUrl='https://edu.9man.com/liveroom';
  export default
  {
    roomstartUrl,       //登录跳转地址
    uploadUrl,          //图片上传地址
    playUrl,            //播放和预览地址
    editUrl,            //编辑的地址
    buyUrl,             //支付宝的购买链接
    liveUrl,            //直播的地址

  }
</script>



// WEBPACK FOOTER //
// src/components/globalvalue/GlobalValue.vue